import { Router } from "@frui.ts/screens";
import { attachAutomaticValidator, getValidationMessage } from "@frui.ts/validation";
import { Modules, newNavigationName } from "config";
import { EnforcementUserCreateValidationRules } from "entities/enforcementTabletUserCreateRequest";
import { computed } from "mobx";
import EventBus from "services/eventBus";
import LocalizationService from "services/localizationService";
import NotificationService from "services/notificationService";
import { UserType } from "../../../entities/userType";
import EnforcementUserRepository from "../../../repositories/enforcementUserRepository";
import OptionsService from "services/optionsService";
import CreateViewModel from "../../createViewModel";
import EnforcementTabletUserCreateRequest from "entities/enforcementTabletUserCreateRequest";

@Router.registerRoute({ route: newNavigationName, name: Router.Self })
export default class EnforcementUserCreateViewModel extends CreateViewModel<EnforcementTabletUserCreateRequest> {
  readonly modelName = "enforcementUser";

  constructor(
    protected repository: EnforcementUserRepository,
    protected localizationService: LocalizationService,
    protected notificationService: NotificationService,
    protected eventBus: EventBus,
    private optionsService: OptionsService
  ) {
    super();
    this.navigationName = newNavigationName;
  }

  protected loadDetail() {
    const item = new EnforcementTabletUserCreateRequest();
    item.isManager = false;
    attachAutomaticValidator(item, EnforcementUserCreateValidationRules, false);
    return item;
  }

  protected postData() {
    return this.repository.create(this.item);
  }

  @computed
  get enforcementUserTypeOptions() {
    return this.optionsService.internalEnumOptions(UserType);
  }

  @computed
  get isManager() {
    return this.item?.isManager;
  }

  set isManager(isManager) {
    this.item.isManager = !this.item.isManager;
  }

  @computed
  get isManagerError() {
    return getValidationMessage(this.item, "isManager");
  }

  translate(code: string, size?: number) {
    return this.localizationService.translateModule(Modules.enforcement, `enforcementUsers.${code}`, size);
  }
}
